import { render } from "./AppointmentHistoryCard.vue?vue&type=template&id=7fd4ff6c&scoped=true"
import script from "./AppointmentHistoryCard.vue?vue&type=script&lang=js"
export * from "./AppointmentHistoryCard.vue?vue&type=script&lang=js"

import "./AppointmentHistoryCard.vue?vue&type=style&index=0&id=7fd4ff6c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd4ff6c"]])

export default __exports__